import { Button, Form, Row, Col, Input, InputNumber } from "antd";
import { useRef } from "react";
import { ExpandOutlined } from "@ant-design/icons";
import LocationPicker from "./LocationPicker";
import {
  validateLatitude,
  validateLongitude,
  validatePositiveDecimal,
} from "../utils/validators";

const { TextArea } = Input;

const BasicDeviceInfoTab = ({
  isVirtual,
  mode,
  markerPosition,
  showMap,
  mapRefreshKey,
  setSmallMap,
  openExpandedMap,
  handleMapChange,
}) => {
  const basicInfoRef = useRef(null);

  return (
    <>
      <div ref={basicInfoRef} style={{ padding: 10 }}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter a name",
                },
              ]}
            >
              <Input disabled={mode === "edit"} />
            </Form.Item>
          </Col>

          {mode === "edit" && (
            <Col xs={24} sm={12}>
              <Form.Item name="serialNumber" label="Serial Number">
                <Input disabled />
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  max: 200,
                  message: "Description cannot exceed 200 characters",
                },
              ]}
            >
              <TextArea rows={3} maxLength={200} showCount style={{ resize: 'none' }} />
            </Form.Item>
          </Col>
        </Row>

        {isVirtual && (
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="height"
                label="Height (m)"
                rules={[
                  {
                    required: true,
                    message: "Enter device height",
                  },
                  {
                    type: "number",
                    min: 0,
                    max: 200,
                    message: "Height must be 0–200 m",
                  },
                  { validator: validatePositiveDecimal },
                ]}
              >
                <InputNumber style={{ width: "100%" }} step={0.1} />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Latitude (º)"
              name="latitude"
              rules={[
                {
                  required: true,
                  message: "Enter latitude",
                },
                { validator: validateLatitude },
              ]}
            >
              <InputNumber style={{ width: "100%" }} step={0.000001} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Longitude (º)"
              name="longitude"
              rules={[
                {
                  required: true,
                  message: "Enter longitude",
                },
                { validator: validateLongitude },
              ]}
            >
              <InputNumber style={{ width: "100%" }} step={0.000001} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label="Select location on map">
              <div
                style={{
                  position: "relative",
                  height: 220,
                }}
              >
                <Button
                  type="default"
                  size="small"
                  icon={<ExpandOutlined />}
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    zIndex: 1000,
                    background: "white",
                    border: "1px solid #ddd",
                  }}
                  onClick={openExpandedMap}
                >
                  Expand
                </Button>
                {showMap && (
                  <div style={{ height: "100%" }}>
                    <LocationPicker
                      value={markerPosition}
                      onChange={handleMapChange}
                      disabled={false}
                      setContainerMap={setSmallMap}
                      forceRefresh={mapRefreshKey}
                    />
                  </div>
                )}
              </div>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BasicDeviceInfoTab;
